import React from 'react';

import { TrackingRoute } from 'commons/eventing';

import { FormsList } from './components/FormsList';

export const formsRoutes = [
  {
    path: '',
    element: (
      <TrackingRoute pageName="forms.yourforms">
        <FormsList />
      </TrackingRoute>
    ),
  },
];
